import { removeAccents } from '../removeAccents';
/**
 * Utilitná funkcia pre odstránenie diakritiky z textu (použitie funkcie removeAccents) a nahradenie ďalších znakov pre kompatibilitu s URL
 * @param {string} - Text pre konverziu
 * @param {string} - Znak, ktorym budu nahradene medzery.
 * @returns {string}
 * @example
 * ```javascript
 * import slugify from 'utilities/lib/slugify';
 *
 * const text = 'Utilitné funkcie Sportnet Online';
 * console.log(slugify(text)); // utilitne_funkcie_sportnet_online
 * ```
 */
function slugify(text, replacement) {
    if (replacement === void 0) { replacement = '_'; }
    if (!text) {
        return '';
    }
    return removeAccents(text)
        .toLowerCase()
        .replace(/\s+/g, replacement)
        .replace(/^-+/, '')
        .replace(/-+$/, '');
}
export default slugify;
